export { ResponsiveModal, ModalContent } from "./responsive-modal";
export type {
	ResponsiveModalProps,
	ModalContentProps,
} from "./responsive-modal";
